module.exports = __webpack_public_path__ + "static/business-day-f5b2a9d6413c3ed2abd778432f4fb42b.png";